import { createTheme } from '@material-ui/core/styles';

export default createTheme({
  typography: {
    // fontFamily: "Roboto, Source Sans Pro"
    body1: {
      fontSize: '0.9rem',
    }
  },
  palette: {
    secondary: {
      main: "#f44336",
    },
    text: {
      primary: "#4D4F5C"
    }
  },
});
